function Inprogress (){
  return (
    <div>
      <img src="../../images/Bluebonnetlogolg.png" style={{width:"100%"}} alt="bluebonet bakery logo"/>
    </div>
  )
}

export default Inprogress